// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"f67e992f","298":"9b9f5fae","353":"18f58de3","383":"b281afce","453":"40379bae","523":"2d6867d9","541":"5f035866","650":"08cb501e","714":"96b43301","919":"55ce6830","940":"b56c0503","974":"d1309e39","978":"482ec878"}[chunkId] + ".chunk.js";
};